export const billStatusList: {
  [key: string]: string
} = {
  "1": "Open",
  "2": "Close",
  "3": "Credit",
  "": ""
}